export default __webpack_public_path__ + "static/media/share_instagram.bbd61ffc.png";